import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'
import { EmployeeManagementType } from '../Actions'
import {
  GET_EMPLOYEE_ACTION,
  GET_BRANCH_ACTION,
  GET_DEPARTMENT_ACTION,
  ADD_EMPLOYEE_ACTION,
  EDIT_EMPLOYEE_ACTION,
  ADD_BULK_EMPLOYEE_HISTORY_ACTION,
} from '../constants/action-types'

const initialState = {
  isLoading: false,
  errorMessage: '',
  employeeList: [],
  departmentList: [],
  branchList: [],
  employeeBulkHistory: [],
}

const reducer = persistReducer(
  { storage, key: 'employee-management', whitelist: [] },
  (state: EmployeeManagementType = initialState, action: ActionTypes) => {
    switch (action.type) {
      //For department
      case GET_DEPARTMENT_ACTION.GET_DEPARTMENT_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }

      case GET_DEPARTMENT_ACTION.GET_DEPARTMENT_LIST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          departmentList: action.payload as any,
        }

      case GET_DEPARTMENT_ACTION.GET_DEPARTMENT_LIST_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      //For branch
      case GET_BRANCH_ACTION.GET_BRANCH_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }

      case GET_BRANCH_ACTION.GET_BRANCH_LIST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          branchList: action.payload as any,
        }

      case GET_BRANCH_ACTION.GET_BRANCH_LIST_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }
      // For get employee
      case GET_EMPLOYEE_ACTION.GET_EMPLOYEE_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }

      case GET_EMPLOYEE_ACTION.GET_EMPLOYEE_LIST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          employeeList: action.payload as any,
        }

      case GET_EMPLOYEE_ACTION.GET_EMPLOYEE_LIST_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      // For add employee
      case ADD_EMPLOYEE_ACTION.ADD_EMPLOYEE_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }

      case ADD_EMPLOYEE_ACTION.ADD_EMPLOYEE_LIST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      case ADD_EMPLOYEE_ACTION.ADD_EMPLOYEE_LIST_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      // For add employee
      case EDIT_EMPLOYEE_ACTION.EDIT_EMPLOYEE_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }

      case EDIT_EMPLOYEE_ACTION.EDIT_EMPLOYEE_LIST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      case EDIT_EMPLOYEE_ACTION.EDIT_EMPLOYEE_LIST_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      // For add employee bulk history
      case ADD_BULK_EMPLOYEE_HISTORY_ACTION.ADD_BULK_EMPLOYEE_LIST_HISTORY_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }

      case ADD_BULK_EMPLOYEE_HISTORY_ACTION.ADD_BULK_EMPLOYEE_LIST_HISTORY_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          employeeBulkHistory: action.payload as any,
        }

      case ADD_BULK_EMPLOYEE_HISTORY_ACTION.ADD_BULK_EMPLOYEE_LIST_HISTORY_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }
      default:
        return state
    }
  }
)

export default reducer
